// import trumbowyg


// admin.js
$(function() {

	// when clicking on [data-confirm] element, ask for confirmation
	$(document).on('click','[data-confirm]',function(e) {
		if( !confirm( $(this).data('confirm') ) ) {
			e.preventDefault();
			e.stopImmediatePropagation();
		}
	});

	// when clicking on [data-method] element
	$(document).on('click','[data-method]',function(e) {
		e.preventDefault();

		// set action to data-href or href if defined
		$('#data-method').attr('action',$(this).data('href') || $(this).attr('href') );

		// set method to defined data-method attribute (or POST if not defined)
		$('#data-method input[name=_method]').val($(this).data('method') || 'POST');

		// submit form
		$('#data-method').submit();
	});


	// when clicking on [data-href] element, load href (as if it were a link)
	// $(document).on('click','[data-href]',function(e) {

	// 	// prevent if selecting text
	// 	if ( window.getSelection().toString() ) return;
		
	// 	e.preventDefault();
	// 	document.location.href = $(this).data('href');
	// });


	/*
	// init trumbowyg editors
	$('.js-editor').trumbowyg({
	    btns: [
	        // ['viewHTML'],
	        // ['formatting'],
	        ['strong', 'em', 'del'],
	        ['superscript', 'subscript'],
	        ['link'],
	        // ['insertImage'],
	        ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
	        ['unorderedList', 'orderedList'],
	        ['horizontalRule'],
	        ['removeformat'],
	        // ['fullscreen']
	        // ['undo', 'redo'], // Only supported in Blink browsers
	    ]
	});
	/*/
	// init ckeditor4 
	// https://ckeditor.com/docs/ckeditor4/latest/guide/dev_installation.html
	$('.js-editor').each( function() {

		CKEDITOR.replace( this, {
		    language: 'fr', 
		    customConfig: '',
		    extraPlugins: "justify,removeformat",
		    toolbar: [
		        [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript' ],
		        [ 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ],
		        [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote' ],
		        [ 'Link', 'Unlink' ],
		        [ 'Table', 'HorizontalRule', 'SpecialChar' ],
		        [ 'RemoveFormat' ],
		        [ 'About' ]
		        // [ 'Source', '-', 'Maximize' ]
	    	]
		});
	});
	//*/


	// show toast flash messages
	$('.toast').each(function() {
		var toast = bootstrap.Toast.getOrCreateInstance(this);
		toast.show();
	})

	// init tooltips in admin-nav
	$('[data-bs-toggle="tooltip"]').each( function() {
		// var tooltip = bootstrap.Tooltip.getOrCreateInstance(this);
		// tooltip.show();
	});


	/**
	 * Chunk upload
	 * using resumablejs
	 */
	$('button.js-upload').each( function() {

		var resumable = new Resumable({
		    // Use chunk size that is smaller than your maximum limit due a resumable issue
		    // https://github.com/23/resumable.js/issues/51
		    chunkSize: 1 * 1024 * 1024, // 1MB
		    // simultaneousUploads: 3,
		    maxFiles: 1,
		    testChunks: false,
		    throttleProgressCallbacks: 1,
		    // Get the url from data-url tag
		    target: $(this).data('url'),
		    // Append token to the request - required for web routes
		    query:{_token : $('input[name=_token]').val()}
		});

		resumable.assignBrowse(this);

		var span = $(this).next('span');
		var input = $(span).next('input');
		input.data('resumable',resumable).hide().trigger('ready.resumable',[resumable]);

		// function that display human readable file size
		var fsize = function( size ) {
			var i = Math.floor( Math.log(size) / Math.log(1024) );
			return ( size / Math.pow(1024, i) ).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
		}

		// Handle file add event
        resumable.on('fileAdded', function (file) {
            span.text( file.fileName ).removeClass('text-danger');
            resumable.upload();
        });

        resumable.on('fileSuccess', function (file, message) {
            var result = JSON.parse(message);
			span.html( $('<a/>', { href:result.href, text: result.name, target: '_blank' } )).append( ' - '+fsize( result.size ) );
			input.val( result.name ).trigger('uploaded',result);
        });

        resumable.on('fileError', function (file, message) {
            span.text( message ).addClass('text-danger');
        });

        resumable.on('fileProgress', function (file) {
            span.text( file.fileName + ' - ' + fsize( file.size ) + ' ('+ Math.floor(resumable.progress() * 100) + '%)' );
        });
	});
});
